/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AcknowledgeRiskPolicyChallengeResponseBody = {
  /**
   * Whether the challenge is now acknowledged.
   */
  acknowledged: boolean;
  /**
   * RFC3339 time until which the acknowledgement suppresses re-challenge.
   */
  expiresAt?: Date | undefined;
  /**
   * The policy that issued the warning.
   */
  policyName?: string | undefined;
};

/** @internal */
export const AcknowledgeRiskPolicyChallengeResponseBody$inboundSchema:
  z.ZodMiniType<AcknowledgeRiskPolicyChallengeResponseBody, unknown> = z.pipe(
    z.object({
      acknowledged: z.boolean(),
      expires_at: z.optional(
        z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
      ),
      policy_name: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        "expires_at": "expiresAt",
        "policy_name": "policyName",
      });
    }),
  );

export function acknowledgeRiskPolicyChallengeResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<
  AcknowledgeRiskPolicyChallengeResponseBody,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      AcknowledgeRiskPolicyChallengeResponseBody$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'AcknowledgeRiskPolicyChallengeResponseBody' from JSON`,
  );
}
